
import { defineComponent } from "vue";
import NetworkImageComponent from "@/components/NetworkImageComponent.vue";
import BasePlayerComponent from "@/components/player/BasePlayerComponent.vue";

export default defineComponent({
    name: "MiniPlayerComponent",
    components: { NetworkImageComponent },
    extends: BasePlayerComponent,
});
